import { getMediaFromConversation } from "V2.0/services/conversationService";
import { showErrorToast } from "V2.0/utils";

async function getMedia({ projectId, conversationId, mediaId }) {
  try {
    const response = await getMediaFromConversation({
      projectId,
      conversationId,
      mediaId,
    });

    const data = response.data;
    const type = data.type.split("/")[1];
    const url = URL.createObjectURL(data);

    return { url, type };
  } catch (e) {
    showErrorToast(e, "Failed to get media");
  }
}

export { getMedia };
